export function requiredPermissionsExists(...args) {
    const [requiredPermissions, grantedPermissions] = args;
    if (Array.isArray(requiredPermissions) && Array.isArray(grantedPermissions)) {
        return requiredPermissions.some((permission) => grantedPermissions.includes(permission));
    }
    if (!Array.isArray(requiredPermissions) &&
        !Array.isArray(grantedPermissions)) {
        const services = Object.keys(requiredPermissions);
        if (services.length === 0) {
            return true;
        }
        for (const service in services) {
            const serviceName = services[service];
            if (grantedPermissions[serviceName]) {
                return requiredPermissionsExists(requiredPermissions[serviceName], grantedPermissions[serviceName]);
            }
        }
        return false;
    }
    // Unreachable: the overloads guarantee both args are always the same type.
    return false;
}
//# sourceMappingURL=check-permissions.js.map